module.exports = require("encoding-down");